/* Added the following code for Istiyak using AI Agent. August 24, 2026. Code Start */
import React from 'react';

/**
 * Route config for Recruiter Performance.
 * Visible only when /auth returns permission code 29 in pages and write.
 * Do not add a separate daily-report route.
 */
const RecruiterPerformanceConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/recruiter-performance',
			component: React.lazy(() => import('./RecruiterPerformance'))
		}
	]
};

export default RecruiterPerformanceConfig;
/* Code end. Istiyak using AI Agent. August 24, 2026 */
